export default "/fcbcac1db17390110677298f9d30eeed9c121039/8e8641da5546a83267ff7cb844712535.svg";